'use client';
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ContentHeading } from './ContentHeading/ContentHeading';
import { ContentWeOffer } from './ContentWeOffer/ContentWeOffer';
import { ContentBanner } from './ContentBanner/ContentBanner';
import { ContentWhy } from './ContentWhy/ContentWhy';

export const Content = ({ data }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true }); // Анимация сработает только один раз

  return (
    <motion.div
      className="flex flex-col gap-y-24"
      ref={ref}
      initial={{ opacity: 0 }} // Начальная прозрачность
      animate={isInView ? { opacity: 1 } : {}} // Анимация при появлении
      transition={{ duration: 0.5 }} // Длительность анимации
    >
      <ContentHeading
        title={data.title}
        description={data.description}
        image={data.image}
      />
      <ContentWeOffer title={data.offer_title} items={data.offer_data} />
      <ContentBanner
        title={data.banner_title}
        description={data.banner_description}
        bookServiceButton={data.bookServiceButton}
      />
      <ContentWhy
        title={data.why_title}
        description={data.why_description}
        items={data.why_items}
        footerText={data.why_footerText}
      />
    </motion.div>
  );
};
